import React from "react";
import { SvgIcon } from "@material-ui/core";

const MyProfile = props => (
  <SvgIcon viewBox="0 0 16.625 19" {...props}>
    <path 
      id="Trazado_2279" 
      data-name="Trazado 2279" 
      d="M11.637,10.688c-1.065,0-1.577.594-3.325.594s-2.256-.594-3.325-.594A4.989,4.989,0,0,0,0,15.675v1.544A1.782,1.782,0,0,0,1.781,19H14.844a1.782,1.782,0,0,0,1.781-1.781V15.675A4.989,4.989,0,0,0,11.637,10.688Zm3.8,6.531a.6.6,0,0,1-.594.594H1.781a.6.6,0,0,1-.594-.594V15.675a3.8,3.8,0,0,1,3.8-3.8c.727,0,1.451.594,3.325.594s2.6-.594,3.325-.594a3.8,3.8,0,0,1,3.8,3.8ZM8.313,9.5a4.75,4.75,0,1,0-4.75-4.75A4.75,4.75,0,0,0,8.313,9.5Zm0-8.312A3.563,3.563,0,1,1,4.75,4.75,3.568,3.568,0,0,1,8.313,1.188Z"
      fill="rgba(112,112,112,0.35)" 
    />
  </SvgIcon>
);

export default MyProfile;